// Shared maths + vocab for Bundles & Bribes (mirrors backend _plan_numbers).
export const BRIBE_TYPES = [
  ["product", "Complimentary product"],
  ["service", "Complimentary service"],
  ["addon", "Complimentary add-on"],
  ["upgrade", "Free upgrade"],
  ["priority_booking", "Priority booking"],
  ["price_lock", "Price lock"],
  ["custom", "Custom perk"],
];

export const emptyRules = () => ({
  valid_amount: 12, valid_unit: "months", expiry_from: "purchase", transferable: false, refundable: false, pausable: false, max_pause_days: 0,
  extendable: false, substitutable: false, unused_creditable: false, no_show_redeems: true, late_cancel_redeems: true, late_cancel_hours: 24,
  interval_note: "", price_locked: true, custom_terms: "",
});

export const emptyPlan = () => ({ name: "", internal_name: "", description: "", active: true, online: true, staff_only: false, display_order: 0, price: "", bundle: [], bribes: [], rules: emptyRules() });

const n = (v) => parseFloat(v) || 0;

export function planNumbers(p) {
  const bundleValue = (p.bundle || []).reduce((s, b) => s + n(b.unit_price) * (parseInt(b.qty, 10) || 0), 0);
  const sessions = (p.bundle || []).reduce((s, b) => s + (parseInt(b.qty, 10) || 0), 0);
  const price = n(p.price);
  const saving = bundleValue - price;
  const bribeValue = (p.bribes || []).reduce((s, b) => s + n(b.value) * (parseInt(b.qty, 10) || 1), 0);
  const bribeCost = (p.bribes || []).reduce((s, b) => s + n(b.cost) * (parseInt(b.qty, 10) || 1), 0);
  return {
    bundle_value: bundleValue, sessions_total: sessions, price, treatment_saving: saving, bribe_value: bribeValue,
    total_value: bundleValue + bribeValue, total_advantage: saving + bribeValue,
    effective_discount_pct: bundleValue ? (saving / bundleValue) * 100 : 0,
    revenue_per_treatment: sessions ? price / sessions : 0, bribe_cost: bribeCost, total_cost_to_business: saving + bribeCost,
  };
}

export const ruleLines = (r, cur, fmt) => {
  if (!r) return [];
  const out = [];
  if (r.valid_amount > 0) out.push(`Valid for ${r.valid_amount} ${r.valid_unit}${r.expiry_from === "first_redemption" ? " from first treatment" : r.expiry_from === "manual" ? " from an agreed start date" : " from purchase"}`);
  out.push(r.transferable ? "Transferable" : "Non-transferable");
  out.push(r.refundable ? "Refundable" : "Non-refundable");
  if (r.pausable) out.push(`Can be paused${r.max_pause_days ? ` (up to ${r.max_pause_days} days)` : ""}`);
  if (r.extendable) out.push("Expiry can be extended on request");
  if (r.substitutable) out.push("Treatments may be substituted");
  if (r.unused_creditable) out.push("Unused value can be credited to another service");
  if (r.no_show_redeems) out.push("A no-show counts as a redeemed treatment");
  if (r.late_cancel_redeems) out.push(`Cancelling with less than ${r.late_cancel_hours || 24}h notice may count as redeemed`);
  if (r.interval_note) out.push(`Recommended ${r.interval_note}`);
  if (r.price_locked) out.push("Price locked for the package duration");
  if (r.custom_terms) out.push(r.custom_terms);
  return out;
};
